(ns ui.components.icon-choice.view
  (:require [ui.util :as uu]
            [ui.dom-globals :as dg]))

;; A small segmented-control style icon chooser.
;;
;; Usage:
;;   [icon-choice/view
;;    {:value :grid
;;     :on-change (fn [v] (rf/dispatch ...))
;;     :items [{:value :kanban :icon [:i.fal.fa-columns] :title "Kanban"}
;;             {:value :grid   :icon [:i.fal.fa-th]      :title "Grid"}
;;             {:value :world  :icon [:i.fal.fa-globe]   :title "World"}]}]
;;
;; Notes:
;; - `:value` is the currently selected item value.
;; - Clicking an item calls `:on-change` with that item's `:value`.
;; - `:disabled?` (optional) disables all interactions.
;; - Each item may include:
;;   - :value (required)
;;   - :icon  (required) hiccup
;;   - :title (optional) tooltip/title
;;   - :disabled? (optional)

(defn view
  [{:keys [items value on-change class disabled?]
    :or   {items []
           class ""}}]
  (let [disabled-all? (true? disabled?)]
    [:div
     {:class (uu/cm
              "inline-flex items-center"
              "rounded-md overflow-hidden"
              "border border-solid border-base-light-border-paler"
              "bg-base-regular"
              class)
      :role "group"}

     (for [{:keys [item-value icon title disabled?]}
           (map (fn [it]
                  (if (contains? it :value)
                    (assoc it :item-value (:value it))
                    it))
                items)
           :let [selected? (= item-value value)
                 disabled-item? (or disabled-all? (true? disabled?))]]
       ^{:key (str "icon-choice-" (pr-str item-value))}
       [:button
        {:type "button"
         :title (or title "")
         :aria-pressed selected?
         :disabled disabled-item?
         :class (uu/cm
                 "w-8 h-7"
                 "flex items-center justify-center"
                 "border-0"
                 "focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary-light-border-accent"
                 "transition"
                 (if selected?
                   "bg-primary-light text-primary-light-text-accent shadow-inner ring-2 ring-inset ring-primary-light-border-accent"
                   "bg-transparent text-base-light-text-paler hover:text-base-light-text hover:bg-base-light")
                 (when disabled-item?
                   "opacity-50 cursor-not-allowed")
                 "[&>i]:pointer-events-none")
         :on-click (fn [e]
                     (dg/prevent-and-stop e)
                     (when (and (not disabled-item?) on-change)
                       (on-change item-value)))}
        icon])]))
